var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoMedicine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#F0F0F0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8912_141107)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.5 41.5C33.7426 41.5 34.75 40.4926 34.75 39.25C34.75 38.0074 33.7426 37 32.5 37C31.2574 37 30.25 38.0074 30.25 39.25C30.25 40.4926 31.2574 41.5 32.5 41.5Z",
    fill: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 34H31V28H34C34.7956 28 35.5587 27.6839 36.1213 27.1213C36.6839 26.5587 37 25.7956 37 25C37 24.2044 36.6839 23.4413 36.1213 22.8787C35.5587 22.3161 34.7956 22 34 22H31C30.2046 22.0009 29.4421 22.3173 28.8797 22.8797C28.3173 23.4421 28.0009 24.2046 28 25V25.75H25V25C25.0018 23.4092 25.6345 21.8842 26.7593 20.7593C27.8842 19.6345 29.4092 19.0018 31 19H34C35.5913 19 37.1174 19.6321 38.2426 20.7574C39.3679 21.8826 40 23.4087 40 25C40 26.5913 39.3679 28.1174 38.2426 29.2426C37.1174 30.3679 35.5913 31 34 31V34Z",
    fill: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6719 47.5508C51.1723 45.7552 52.2725 43.6602 52.8991 41.4056C53.5257 39.151 53.6642 36.7887 53.3055 34.4764C52.9468 32.164 52.0991 29.9547 50.8189 27.9959C49.5388 26.0372 47.8556 24.3739 45.8817 23.1172L44.3832 25.7122C46.339 26.9917 47.929 28.7573 48.9974 30.836C50.0659 32.9147 50.5761 35.2352 50.4783 37.5704C50.3804 39.9056 49.6777 42.1753 48.439 44.1572C47.2004 46.1392 45.4682 47.7655 43.4121 48.8769C41.3561 49.9883 39.0466 50.5466 36.7099 50.4972C34.3733 50.4479 32.0894 49.7925 30.0822 48.5952C28.0749 47.398 26.413 45.6999 25.2591 43.6674C24.1053 41.6349 23.4992 39.3375 23.5 37.0003H20.5C20.4976 40.136 21.3894 43.2074 23.0709 45.8541C24.7524 48.5008 27.1538 50.6132 29.9934 51.9434C32.8329 53.2736 35.993 53.7664 39.1028 53.3641C42.2125 52.9618 45.1431 51.681 47.5507 49.672L58.8789 61.0003L61 58.8791L49.6719 47.5508Z",
    fill: "#9B9B9B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8912_141107"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoMedicine);
export default __webpack_public_path__ + "static/media/noMedicine.196a20615919b5fe09c48d6cc59cd5ce.svg";
export { ForwardRef as ReactComponent };